import { useSuspenseQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetEmpreendimentosDisponiveisService } from '@/features/empreendimentos/brasil/http/get-empreendimentos-disponiveis.service'
import type { TGetEmpreendimentosDisponiveisResponse } from '@/features/empreendimentos/brasil/types/empreendimento'
import { empreendimentosKeys } from '@/features/empreendimentos/shared/utils/queries'

export const useEmpreendimentosDisponiveisSuspense = () => {
  return useSuspenseQuery<TGetEmpreendimentosDisponiveisResponse, AxiosError>({
    queryKey: empreendimentosKeys.disponiveis(),
    queryFn: () => new GetEmpreendimentosDisponiveisService().execute().then((response) => response.data),
  })
}
